import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "static-body bg-gondola" }
const _hoisted_2 = {
  class: "container mw-1356",
  style: {"max-width":"960px"}
}
const _hoisted_3 = { class: "download-box" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "steps-list" }
const _hoisted_6 = { class: "step-number" }
const _hoisted_7 = { class: "step-content" }
const _hoisted_8 = { class: "help-box" }
const _hoisted_9 = { class: "device-section" }
const _hoisted_10 = { class: "device-tabs" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "device-guide" }
const _hoisted_13 = { class: "guide-steps" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "guide-note"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MainFooter = _resolveComponent("MainFooter")!
  const _component_CopyRight = _resolveComponent("CopyRight")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "static-hero" }, [
      _createElementVNode("div", { class: "container mw-1356" }, [
        _createElementVNode("span", { class: "top-title" }, "Installation Guide"),
        _createElementVNode("h1", null, "How to Install Our IPTV STREAM+ Service"),
        _createElementVNode("p", null, "Get set up and streaming in minutes — follow the steps below for your device")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "download-info" }, [
            _createElementVNode("h2", null, [
              _createElementVNode("i", { class: "ti ti-brand-android" }),
              _createTextVNode(" Get the App (IBO Pro Player)")
            ]),
            _createElementVNode("p", null, [
              _createTextVNode(" Download IBO Pro Player (APK) — the easiest way to watch on Android TV boxes, Fire TV and Android phones. Install it, then follow the "),
              _createElementVNode("strong", null, "IBO Pro Player"),
              _createTextVNode(" setup steps below to add your playlist. ")
            ])
          ], -1)),
          _createElementVNode("a", {
            href: _ctx.apkUrl,
            class: "btn download-btn",
            target: "_blank",
            rel: "noopener",
            download: ""
          }, _cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "ti ti-download" }, null, -1),
            _createTextVNode(" Download App (APK) ")
          ]), 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generalSteps, (step, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "step-card",
              key: i
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(i + 1), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", null, _toDisplayString(step.title), 1),
                _createElementVNode("p", null, _toDisplayString(step.text), 1)
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("h3", null, [
            _createElementVNode("i", { class: "ti ti-headset" }),
            _createTextVNode(" Need help?")
          ], -1)),
          _cache[4] || (_cache[4] = _createElementVNode("p", null, " If you encounter any problems or have any questions, please contact our customer support for assistance. Our friendly and knowledgeable representatives are available to help you resolve any technical issues or answer any questions you may have. ", -1)),
          _createVNode(_component_RouterLink, {
            to: "/contact-us",
            class: "btn help-btn"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Contact Support")
            ])),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Select Your Device", -1)),
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (device) => {
              return (_openBlock(), _createElementBlock("button", {
                key: device.id,
                class: _normalizeClass(["device-tab", { active: _ctx.activeDevice === device.id }]),
                onClick: ($event: any) => (_ctx.activeDevice = device.id)
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(device.icon)
                }, null, 2),
                _createTextVNode(" " + _toDisplayString(device.label), 1)
              ], 10, _hoisted_11))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.currentDevice.guideTitle), 1),
            _createElementVNode("ol", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDevice.steps, (step, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  innerHTML: step
                }, null, 8, _hoisted_14))
              }), 128))
            ]),
            (_ctx.currentDevice.note)
              ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ti ti-info-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.currentDevice.note), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_MainFooter),
    _createVNode(_component_CopyRight)
  ]))
}